<script>
    /**
     * SPDX-FileCopyrightText: 2012-2026 Open Assessment Technologies S.A.
     * Copyright (C) 2026 (original work) Open Assessment Technologies S.A.
     *
     * SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-TAO-Commercial-License
     */

    import { Button } from '@oat-sa-private/ui-elements';
    import { __ } from '@oat-sa-private/ui-core';

    let { key, onmodalFeedbackContinue } = $props();
</script>

<style>
    .modalfeedback-nav {
        height: var(--nav-height, 9rem);
        @add-mixin flex-center-center;
    }
</style>

<div class="modalfeedback-nav">
    <Button shape="pill" size="small" label={__('Continue')} on:click={() => onmodalFeedbackContinue?.({ key })} />
</div>
